var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CardContent, Typography } from "@mui/material";
import { CardOverImageTitle, CardWithShadow, ShareArea } from "@nitra/nkmb-card-components/cards";
import { useIsMobileContext } from "@nitra/nkmb-card-components/contexts";
import { getLocalizedString } from "@nitra/nkmb-card-components/utils";
import { useTranslation } from "react-i18next";
export function StadiumLegendaryMatchCard(props) {
    var forceMobile = props.forceMobile;
    var _a = props.data, key = _a.key, image368x141url = _a.image368x141url, image288x360url = _a.image288x360url, title = _a.title, subTitle = _a.subTitle;
    var isMobile = useIsMobileContext();
    var i18n = useTranslation().i18n;
    var currentLang = i18n.language;
    return (_jsxs(CardWithShadow, __assign({ to: key, fullSizeImageUrl: (isMobile || forceMobile) ? image368x141url : image288x360url, sx: { position: "relative", display: "flex", flexDirection: "column", }, fixedWidth: (isMobile || forceMobile) ? undefined : 288, cardHeightOverride: (isMobile || forceMobile) ? 141 : undefined }, { children: [_jsxs(CardContent, __assign({ sx: { zIndex: 1, mt: "auto", position: "relative", mb: 2 } }, { children: [_jsx(CardOverImageTitle, { variant: "podnaslovS", title: title }), subTitle &&
                        _jsx(Typography, __assign({ variant: "bodyS", sx: { zIndex: 1, color: "rgba(255,255,255,0.65)" } }, { children: getLocalizedString(subTitle, currentLang) }))] })), _jsx(ShareArea, { shareUrl: "/club/stadium/legendaryMatches/".concat(key), brightText: true, sx: { position: "absolute", right: 16, bottom: 16, zIndex: 11 } })] })));
}
